import {
  ConditionType,
  PaymentInOutFlowType,
  PndType,
  SettingWhtItem40XShowingType,
  TaxIncomeType,
  TransactionType,
  WHTCertItemType,
  WhtRateType,
  WithholdingTaxPageSizeType,
} from "@/enums/enums";
import { ContactModel } from "@/model/contact/contactModel";
import { SettingWitholdingTaxDocumentTemplateModel } from "@/model/document/settingDocumentTemplate";
import {
  TaxIncomeTypeModel,
  TaxIncomeTypeTemplateModel,
  WithholdingTaxDocumentTemplateModel,
  WitholdingTaxDocumentModel,
  WitholdingTaxItemDocumentModel,
  WitholdingTaxOnlineViewModel,
} from "@/model/document/witholdingTaxDocumentModal";
import { MerchantDetail } from "@/model/merchant/merchantModel";
import { UserInfoModel } from "@/model/user/userModel";
import { GetDocumentContact, GetDocumentMerchant, GetDocumentTags, GetDocumentUser } from "./documentFacadeHelper";
import { GetSignatureUrlUserApprove, GetSignatureUrlUserCreate } from "./documentHelper";

export function GetWitholdingTaxItemDocument(
  _witholdingTaxItemDocumentList: any
): Array<WitholdingTaxItemDocumentModel> {
  const witholdingTaxItemDocumentList = new Array<WitholdingTaxItemDocumentModel>();

  if (_witholdingTaxItemDocumentList && _witholdingTaxItemDocumentList.length > 0) {
    const mockWhtModel: any = {};
    var result = _witholdingTaxItemDocumentList.reduce(function (result: any, object: any) {
      var key = object.taxIncomeType + "-" + object.whtRate;
      if (!mockWhtModel[key]) {
        mockWhtModel[key] = Object.assign({}, object);
        result.push(mockWhtModel[key]);
      } else {
        mockWhtModel[key].preTaxAmount += object.preTaxAmount;
        mockWhtModel[key].whtAmount += object.whtAmount;
      }

      return result;
    }, []);
    result.forEach((witholdingTaxItem: any) => {
      const witholdingTaxItemDocument: WitholdingTaxItemDocumentModel = {
        whtItemId: witholdingTaxItem.whtItemId ? witholdingTaxItem.whtItemId : 0,
        description: witholdingTaxItem.description ? witholdingTaxItem.description : "",
        taxIncomeType: witholdingTaxItem.taxIncomeType ? witholdingTaxItem.taxIncomeType : TaxIncomeType.None,
        preTaxAmount: witholdingTaxItem.preTaxAmount ? witholdingTaxItem.preTaxAmount : 0,
        whtAmount: witholdingTaxItem.whtAmount ? witholdingTaxItem.whtAmount : 0,
        whtRate: witholdingTaxItem.whtRate ? witholdingTaxItem.whtRate : 0,
      };
      witholdingTaxItemDocumentList.push(witholdingTaxItemDocument);
    });
  }

  return witholdingTaxItemDocumentList;
}

export function GetWitholdingTaxDocumentData(data: any): WitholdingTaxDocumentModel {
  const documentDataModel: WitholdingTaxDocumentModel = {
    whtId: data.whtId ? data.whtId : 0,
    whtNumber: data.whtNumber ? data.whtNumber : "",
    whtDate: data.whtDate ? data.whtDate.ToDateTimezone() : "",
    paymentFlowType: data.paymentFlowType ? data.paymentFlowType : PaymentInOutFlowType.None,
    pndType: data.pndType ? data.pndType : PndType.None,
    subTotal: data.subTotal ? data.subTotal : 0,
    whtTotal: data.whtTotal ? data.whtTotal : 0,
    description: data.description ? data.description : "",
    remark: data.remark ? data.remark : "",
    referenceOne: data.referenceOne ? data.referenceOne : "",
    referenceTwo: data.referenceTwo ? data.referenceTwo : "",
    createdDateTime: data.createdDateTime ? data.createdDateTime.ToDateTimezone() : "",
    createdUser: data.createdUser ? GetDocumentUser(data.createdUser) : new UserInfoModel(),
    updatedDateTime: data.updatedDateTime ? data.updatedDateTime.ToDateTimezone() : "",
    updatedUser: data.updatedUser ? GetDocumentUser(data.updatedUser) : new UserInfoModel(),
    approvedDateTime: data.approvedDateTime ? data.approvedDateTime.ToDateTimezone() : "",
    approvedUser: data.approvedUser ? GetDocumentUser(data.approvedUser) : new UserInfoModel(),
    contact: data.contact ? GetDocumentContact(data.contact) : new ContactModel(),
    merchant: data.merchant ? GetDocumentMerchant(data.merchant) : new MerchantDetail(),
    tags: data.tags ? GetDocumentTags(data.tags) : [],
    witholdingTaxItemDocumentModel: data.whtItemList ? GetWitholdingTaxItemDocument(data.whtItemList) : [],
    pensionFundAmount: data.pensionFundAmount ? data.pensionFundAmount : 0,
    socialSecurityAmount: data.socialSecurityAmount ? data.socialSecurityAmount : 0,
    providentFundAmount: data.providentFundAmount ? data.providentFundAmount : 0,
    isDeleted: data.isDeleted ? data.isDeleted : false,
    conditionType: data.whtDeductType ? data.whtDeductType : ConditionType.None,
  };
  return documentDataModel;
}

export function GetTaxIncomeTypeForWithholdingFullCreate(whtCertItemType: WHTCertItemType) {
  const taxIncomeTypeTemplate: TaxIncomeTypeModel = {
    active: false,
    whtCertItemType: whtCertItemType,
    date: new Date().GetDateFormat(),
    incomeType: -1,
    newAmount: 0,
    whtAmount: 0,
    whtRateType: 0,
    description: "",
  };
  return taxIncomeTypeTemplate;
}

export function GetTaxIncomeType(
  taxIncomeTypeTemplate: TaxIncomeTypeTemplateModel,
  documentModel: WitholdingTaxOnlineViewModel
) {
  const witholdingTaxItemDocument = documentModel.document.data.witholdingTaxItemDocumentModel;
  if (witholdingTaxItemDocument && witholdingTaxItemDocument.length > 0) {
    let isHaveWhtCertItem404A = false;
    witholdingTaxItemDocument.forEach((witholdingTaxItem) => {
      switch (witholdingTaxItem.taxIncomeType) {
        //WHTCertItem401
        case TaxIncomeType.SalariesIncome:
        case TaxIncomeType.SalariesIncomeHaveWithholdingTaxRate:
        case TaxIncomeType.SeverancePay:
          taxIncomeTypeTemplate.whtCertItem401.incomeType = witholdingTaxItem.taxIncomeType;
          taxIncomeTypeTemplate.whtCertItem401.newAmount += witholdingTaxItem.preTaxAmount;
          taxIncomeTypeTemplate.whtCertItem401.whtAmount += witholdingTaxItem.whtAmount;
          taxIncomeTypeTemplate.whtCertItem401.whtRateType = witholdingTaxItem.whtRate;
          taxIncomeTypeTemplate.whtCertItem401.description = witholdingTaxItem.description;
          taxIncomeTypeTemplate.whtCertItem401.date = documentModel.document.data.whtDate.GetDateFormatBE();
          break;
        //WHTCertItem402
        case TaxIncomeType.SalariesWorkingIncome:
          taxIncomeTypeTemplate.whtCertItem402.incomeType = witholdingTaxItem.taxIncomeType;
          taxIncomeTypeTemplate.whtCertItem402.newAmount += witholdingTaxItem.preTaxAmount;
          taxIncomeTypeTemplate.whtCertItem402.whtAmount += witholdingTaxItem.whtAmount;
          taxIncomeTypeTemplate.whtCertItem402.whtRateType = witholdingTaxItem.whtRate;
          taxIncomeTypeTemplate.whtCertItem402.description = witholdingTaxItem.description;
          taxIncomeTypeTemplate.whtCertItem402.date = documentModel.document.data.whtDate.GetDateFormatBE();
          break;
        //WHTCertItem403
        case TaxIncomeType.GoodwillAndRightIncome:
          taxIncomeTypeTemplate.whtCertItem403.incomeType = witholdingTaxItem.taxIncomeType;
          taxIncomeTypeTemplate.whtCertItem403.newAmount += witholdingTaxItem.preTaxAmount;
          taxIncomeTypeTemplate.whtCertItem403.whtAmount += witholdingTaxItem.whtAmount;
          taxIncomeTypeTemplate.whtCertItem403.whtRateType = witholdingTaxItem.whtRate;
          taxIncomeTypeTemplate.whtCertItem403.description = witholdingTaxItem.description;
          taxIncomeTypeTemplate.whtCertItem403.date = documentModel.document.data.whtDate.GetDateFormatBE();
          break;
        //WHTCertItem404A
        case TaxIncomeType.InterestOrDiscountIncome:
        case TaxIncomeType.ProfitSharingIncome:
        case TaxIncomeType.BonusToShareholder:
        case TaxIncomeType.PortionOfDecapitalized:
        case TaxIncomeType.IncreasedCapital:
        case TaxIncomeType.BenefitFromConsolidated:
        case TaxIncomeType.BenefitFromTrade:
          taxIncomeTypeTemplate.whtCertItem404A.incomeType = isHaveWhtCertItem404A
            ? TaxIncomeType.BenefitFromTrade
            : witholdingTaxItem.taxIncomeType;
          taxIncomeTypeTemplate.whtCertItem404A.newAmount += witholdingTaxItem.preTaxAmount;
          taxIncomeTypeTemplate.whtCertItem404A.whtAmount += witholdingTaxItem.whtAmount;
          if (isHaveWhtCertItem404A) {
            //เช็ค whtRateType เหมือนกันหมดไหม หากไม่ให้เซ็ตเป็น Custom
            taxIncomeTypeTemplate.whtCertItem404A.whtRateType =
              taxIncomeTypeTemplate.whtCertItem404A.whtRateType === witholdingTaxItem.whtRate
                ? taxIncomeTypeTemplate.whtCertItem404A.whtRateType
                : WhtRateType.Custom;
          } else {
            taxIncomeTypeTemplate.whtCertItem404A.whtRateType = witholdingTaxItem.whtRate;
          }
          taxIncomeTypeTemplate.whtCertItem404A.description += taxIncomeTypeTemplate.whtCertItem404A.description
            ? ", " + witholdingTaxItem.description
            : witholdingTaxItem.description;

          taxIncomeTypeTemplate.whtCertItem404A.date = documentModel.document.data.whtDate.GetDateFormatBE();

          isHaveWhtCertItem404A = true;

          break;
        //WHTCertItem40X
        case TaxIncomeType.AssetRentalIncome:
        case TaxIncomeType.ProfessionalServiceIncome:
        case TaxIncomeType.ContractWorkIncome:
        case TaxIncomeType.HireOfWorkIncome:
        case TaxIncomeType.AdvertisingIncome:
        case TaxIncomeType.PrizeOrRewardIncome:
        case TaxIncomeType.OtherServicesExcludeHotelRestaurantAndInsurance:
        case TaxIncomeType.DiscountOrTradePromotion:
        case TaxIncomeType.Insurance:
        case TaxIncomeType.NonPublicTransport:
        case TaxIncomeType.CelebrityHiring:
          if (taxIncomeTypeTemplate.whtCertItem40X1.incomeType == -1) {
            taxIncomeTypeTemplate.whtCertItem40X1.incomeType = witholdingTaxItem.taxIncomeType;
            taxIncomeTypeTemplate.whtCertItem40X1.newAmount = witholdingTaxItem.preTaxAmount;
            taxIncomeTypeTemplate.whtCertItem40X1.whtAmount = witholdingTaxItem.whtAmount;
            taxIncomeTypeTemplate.whtCertItem40X1.whtRateType = witholdingTaxItem.whtRate;
            taxIncomeTypeTemplate.whtCertItem40X1.description = witholdingTaxItem.description;
            taxIncomeTypeTemplate.whtCertItem40X1.date = documentModel.document.data.whtDate.GetDateFormatBE();
          } else if (taxIncomeTypeTemplate.whtCertItem40X2.incomeType == -1) {
            taxIncomeTypeTemplate.whtCertItem40X2.incomeType = witholdingTaxItem.taxIncomeType;
            taxIncomeTypeTemplate.whtCertItem40X2.newAmount = witholdingTaxItem.preTaxAmount;
            taxIncomeTypeTemplate.whtCertItem40X2.whtAmount = witholdingTaxItem.whtAmount;
            taxIncomeTypeTemplate.whtCertItem40X2.whtRateType = witholdingTaxItem.whtRate;
            taxIncomeTypeTemplate.whtCertItem40X2.description = witholdingTaxItem.description;
            taxIncomeTypeTemplate.whtCertItem40X2.date = documentModel.document.data.whtDate.GetDateFormatBE();
          } else if (taxIncomeTypeTemplate.whtCertItem40X3.incomeType == -1) {
            taxIncomeTypeTemplate.whtCertItem40X3.incomeType = witholdingTaxItem.taxIncomeType;
            taxIncomeTypeTemplate.whtCertItem40X3.newAmount = witholdingTaxItem.preTaxAmount;
            taxIncomeTypeTemplate.whtCertItem40X3.whtAmount = witholdingTaxItem.whtAmount;
            taxIncomeTypeTemplate.whtCertItem40X3.whtRateType = witholdingTaxItem.whtRate;
            taxIncomeTypeTemplate.whtCertItem40X3.description = witholdingTaxItem.description;
            taxIncomeTypeTemplate.whtCertItem40X3.date = documentModel.document.data.whtDate.GetDateFormatBE();
          } else if (taxIncomeTypeTemplate.whtCertItem40X4.incomeType == -1) {
            taxIncomeTypeTemplate.whtCertItem40X4.incomeType = witholdingTaxItem.taxIncomeType;
            taxIncomeTypeTemplate.whtCertItem40X4.newAmount = witholdingTaxItem.preTaxAmount;
            taxIncomeTypeTemplate.whtCertItem40X4.whtAmount = witholdingTaxItem.whtAmount;
            taxIncomeTypeTemplate.whtCertItem40X4.whtRateType = witholdingTaxItem.whtRate;
            taxIncomeTypeTemplate.whtCertItem40X4.description = witholdingTaxItem.description;
            taxIncomeTypeTemplate.whtCertItem40X4.date = documentModel.document.data.whtDate.GetDateFormatBE();
          } else {
            taxIncomeTypeTemplate.whtCertItem40X4.newAmount += witholdingTaxItem.preTaxAmount;
            taxIncomeTypeTemplate.whtCertItem40X4.whtAmount += witholdingTaxItem.whtAmount;
          }
          break;
        case TaxIncomeType.None:
          if (taxIncomeTypeTemplate.whtCertItemOther2.incomeType == -1) {
            taxIncomeTypeTemplate.whtCertItemOther2.incomeType = witholdingTaxItem.taxIncomeType;
            taxIncomeTypeTemplate.whtCertItemOther2.newAmount = witholdingTaxItem.preTaxAmount;
            taxIncomeTypeTemplate.whtCertItemOther2.whtAmount = witholdingTaxItem.whtAmount;
            taxIncomeTypeTemplate.whtCertItemOther2.whtRateType = witholdingTaxItem.whtRate;
            taxIncomeTypeTemplate.whtCertItemOther2.description = taxIncomeTypeTemplate.whtCertItemOther.description
              ? ", " + witholdingTaxItem.description
              : witholdingTaxItem.description;
            taxIncomeTypeTemplate.whtCertItemOther2.date = documentModel.document.data.whtDate.GetDateFormatBE();
          } else {
            taxIncomeTypeTemplate.whtCertItemOther.incomeType = witholdingTaxItem.taxIncomeType;
            taxIncomeTypeTemplate.whtCertItemOther.newAmount += witholdingTaxItem.preTaxAmount;
            taxIncomeTypeTemplate.whtCertItemOther.whtAmount += witholdingTaxItem.whtAmount;
            taxIncomeTypeTemplate.whtCertItemOther.whtRateType = witholdingTaxItem.whtRate;
            taxIncomeTypeTemplate.whtCertItemOther.description += taxIncomeTypeTemplate.whtCertItemOther.description
              ? ", " + witholdingTaxItem.description
              : witholdingTaxItem.description;
            taxIncomeTypeTemplate.whtCertItemOther.date = documentModel.document.data.whtDate.GetDateFormatBE();
          }

          break;
      }
    });
  }
}

export function GetWitholdingTaxDocumentTemplate(
  documentModel: WitholdingTaxOnlineViewModel,
  settingDocumentTemplateDefault?: SettingWitholdingTaxDocumentTemplateModel
): WithholdingTaxDocumentTemplateModel {
  const documentTemplate: WithholdingTaxDocumentTemplateModel = {
    pageSize: documentModel.template.pageSize ?? WithholdingTaxPageSizeType.A4,
    displayType: documentModel.template.displayType,
    showDisplayType: documentModel.template.showDisplayType,
    transactionType: TransactionType.WithholdingTax,
    whtDate: documentModel.document.data.whtDate,
    referenceOne: {
      value: documentModel.document.data.referenceOne,
      isShowElement: documentModel.template.documentNumber.isShowRefOne,
    },
    referenceTwo: {
      value: documentModel.document.data.referenceTwo,
      isShowElement: documentModel.template.documentNumber.isShowRefTwo,
    },
    issueDate: documentModel.document.data.whtDate.ToDateJsonString(),
    paymentFlowType: documentModel.paymentInOutFlowType,
    number: {
      value: documentModel.document.data.whtNumber,
      isShowElement: documentModel.template.documentNumber.isShowWhtNumber,
    },
    merchant: documentModel.document.data.merchant,
    contact: documentModel.document.data.contact,
    pndType: documentModel.document.data.pndType,
    taxIncomeType: {
      whtCertItem401: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem401),
      whtCertItem402: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem402),
      whtCertItem403: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem403),
      whtCertItem404A: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem404A),
      whtCertItem40X1: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem40X1),
      whtCertItem40X2: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem40X2),
      whtCertItem40X3: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem40X3),
      whtCertItem40X4: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItem40X4),
      whtCertItemOther: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItemOther),
      whtCertItemOther2: GetTaxIncomeTypeForWithholdingFullCreate(WHTCertItemType.WHTCertItemOther2),
    },

    summary: {
      newAmount: 0,
      withholdingTax: 0,
      newAmountTextTh: "",
    },
    pensionFund: documentModel.document.data.pensionFundAmount,
    socialSecurityFund: documentModel.document.data.socialSecurityAmount,
    providentFund: documentModel.document.data.providentFundAmount,
    userApprove: {
      isShowSignatureUrl: documentModel.template.certified.isShowUserApproveUrl ?? true,
      isShowApproveDate: documentModel.template.certified.isShowUserApproveDate ?? true,
      isShowApproveName: documentModel.template.certified.isShowUserApproveName ?? true,
      approveDate: new Date(documentModel.document.data.approvedDateTime),
      name:
        documentModel.document.data.approvedUser.firstName + " " + documentModel.document.data.approvedUser.lastName,
      signatureUrl: GetSignatureUrlUserApprove(documentModel),
    },
    userCreate: {
      isShowSignatureUrl: documentModel.template.certified.isShowUserCreateUrl ?? true,
      isShowCreateDate: documentModel.template.certified.isShowUserCreateDate ?? true,
      isShowCreateName: documentModel.template.certified.isShowUserCreateName ?? true,
      createDate: new Date(documentModel.document.data.createdDateTime),
      name: documentModel.document.data.createdUser.firstName + " " + documentModel.document.data.createdUser.lastName,
      signatureUrl: GetSignatureUrlUserCreate(documentModel),
    },
    merchantStampUrl: {
      value: documentModel.credential.merchantCredential.stampUrl,
      isShowElement: documentModel.template.certified.isShowMerchantStampUrl,
    },
    isDeleted: documentModel.document.data.isDeleted,
    conditionType: documentModel.document.data.conditionType,
    whtItem40XShowingType: documentModel.template.whtItem40XShowingType ?? SettingWhtItem40XShowingType.CombinedShowing,
  };

  if (settingDocumentTemplateDefault) {
    documentTemplate.pageSize = settingDocumentTemplateDefault.pageSize ?? WithholdingTaxPageSizeType.A4;
    documentTemplate.displayType = settingDocumentTemplateDefault.displayType;
    documentTemplate.showDisplayType = settingDocumentTemplateDefault.showDisplayType;
    documentTemplate.referenceOne.isShowElement = settingDocumentTemplateDefault.documentNumber.isShowRefOne;
    documentTemplate.referenceTwo.isShowElement = settingDocumentTemplateDefault.documentNumber.isShowRefTwo;
    documentTemplate.number.isShowElement = settingDocumentTemplateDefault.documentNumber.isShowWhtNumber;
    documentTemplate.userApprove.isShowSignatureUrl =
      settingDocumentTemplateDefault.certified.isShowUserApproveUrl ?? true;
    documentTemplate.userApprove.isShowApproveDate =
      settingDocumentTemplateDefault.certified.isShowUserApproveDate ?? true;
    documentTemplate.userCreate.isShowSignatureUrl =
      settingDocumentTemplateDefault.certified.isShowUserCreateUrl ?? true;
    documentTemplate.userCreate.isShowCreateDate =
      settingDocumentTemplateDefault.certified.isShowUserCreateDate ?? true;
    documentTemplate.merchantStampUrl.isShowElement = settingDocumentTemplateDefault.certified.isShowMerchantStampUrl;
    documentTemplate.whtItem40XShowingType =
      settingDocumentTemplateDefault.whtItem40XShowingType ?? SettingWhtItem40XShowingType.CombinedShowing;
  }

  GetTaxIncomeType(documentTemplate.taxIncomeType, documentModel);

  return documentTemplate;
}
